@if (title) {
  <div class="title cell">{{ title }}</div>
}
<ng-content/>
